import { apiClient } from '@/services/apiClient';
import { Routes } from './routes';
import { useMutation } from '@tanstack/react-query';
import type { CreatePaymentSessionResponse } from '@/types/payment';

export const useCreateSession = () => {
  return useMutation({
    mutationFn: async ({
      paymentMethodId,
      email,
    }: {
      paymentMethodId: string;
      email: string;
    }): Promise<CreatePaymentSessionResponse> => {
      const response = await apiClient.post<CreatePaymentSessionResponse>(Routes.CREATE_SESSION, {
        paymentMethodId,
        receipt_email: email,
      });
      return response;
    },
  });
};
